import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ClearanceItem, CIDocument, CIImage, CIRestriction, CITag, CISignedUrl, ListSearchData, MassUpdateData } from './index';
import { AuthService, IUserInfo } from '../shared/core/index';
import 'rxjs/Rx';
import { DomSanitizer } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { HttpService } from '../shared/core/http.service';
import { AppService } from '../app.service';

@Injectable()
export class ClearanceItemImageService {   
    private userInfo: IUserInfo; 

    private ciImageServiceAPIUrl = new URL('ciimage', process.env.API_URL).toString();
    
    private _currentClearanceItem = new BehaviorSubject<ClearanceItem>(new ClearanceItem());
    CurrrentClearanceItem = this._currentClearanceItem.asObservable();

    constructor(private _http: Http, private _httpService: HttpService, private _authService: AuthService, private sanitizer: DomSanitizer, private _appService: AppService) {
        this._authService.subscribeToLoginService().subscribe(r => { this.userInfo = r });
    }

    patchImageNotes(ciimage: CIImage): Observable<boolean> {
        var body = JSON.stringify(ciimage);
        return this._httpService.httpPatch(this.ciImageServiceAPIUrl+'/patchCIImageNotes', body)
            .do((p: Response) => true)
            .catch(e => {
                console.error('updateCICimage:' + e._body);
                return Observable.of<any>(false);
            });
    }
    
    patchImageMarkAsDeleted(ciimage: CIImage): Observable<boolean> {
        var body = JSON.stringify(ciimage);
        return this._httpService.httpPatch(this.ciImageServiceAPIUrl+'/patchCIImageMarkAsDeleted', body)
            .do((p: Response) => true)
            .catch(e => {
                console.error('updateCICimage:' + e._body);
                return Observable.of<any>(false);
            });
    }

    private handleError(error: Response) {
        return Observable.throw(error || 'Server error');
    }

    public getOriginalImagesFullUrls(CI: ClearanceItem): Observable<CISignedUrl>[]{
        return CI.images.map(image => {
            return this._appService.getSignedUrlInline(image.url, CI.projectId,'GET','image','ci',image.urlName);        
        });
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/clearance-item/clearance-item-image.service.ts